import { render, staticRenderFns } from "./LaboratoryImportBranches.vue?vue&type=template&id=3cd34b4e&scoped=true"
import script from "./LaboratoryImportBranches.vue?vue&type=script&lang=js"
export * from "./LaboratoryImportBranches.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryImportBranches.vue?vue&type=style&index=0&id=3cd34b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd34b4e",
  null
  
)

export default component.exports